import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img/mall/goods/left_icon.svg';
import _imports_1 from '@/assets/img/mall/goods/close.svg';
const _withScopeId = n => (_pushScopeId("data-v-1d771d58"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "orderHeaderWrapper" };
const _hoisted_2 = { class: "orderHeader" };
const _hoisted_3 = ["onClick"];
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_0,
    alt: ""
}, null, -1));
const _hoisted_5 = [
    _hoisted_4
];
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "title" }, "确认订单", -1));
const _hoisted_7 = ["onClick"];
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("img", {
    src: _imports_1,
    alt: ""
}, null, -1));
const _hoisted_9 = [
    _hoisted_8
];
import { closeLiveCartList, getUrlParam } from '@/widget/index';
import { useRouter } from 'vue-router';
export default /*#__PURE__*/ _defineComponent({
    setup(__props) {
        const router = useRouter();
        const backFn = () => {
            let liveId = getUrlParam('liveId');
            if (getUrlParam('productId') && liveId) {
                router.replace({
                    path: '/mall/good/list',
                    query: {
                        liveId
                    }
                });
            }
            else {
                history.go(-1);
            }
        };
        const closeFn = () => {
            closeLiveCartList();
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", {
                        class: "left",
                        onClick: _withModifiers(backFn, ["stop"])
                    }, _hoisted_5, 8, _hoisted_3),
                    _hoisted_6,
                    _createElementVNode("div", {
                        class: "close",
                        onClick: _withModifiers(closeFn, ["stop"])
                    }, _hoisted_9, 8, _hoisted_7)
                ])
            ]));
        };
    }
});
